import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { SiteHeader, SiteFooter } from "@/pages/Landing";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-stone-900 text-stone-100 antialiased" data-testid="payment-cancel-page">
      <SiteHeader />
      <div className="max-w-2xl mx-auto px-4 py-24 text-center">
        <XCircle className="w-14 h-14 text-stone-500 mx-auto mb-6" />
        <h1 className="text-3xl font-extrabold uppercase text-white">Checkout Cancelled</h1>
        <p className="text-stone-400 text-sm mt-3">No payment was taken and no date was held. Your spot is still open if you'd like to try again — or call the skipper on <a href="tel:07929834128" className="text-amber-400 font-bold">07929834128</a>.</p>
        <Link to="/book" data-testid="cancel-retry-link" className="inline-block mt-8 px-8 py-3 bg-amber-400 hover:bg-amber-300 text-stone-950 font-bold uppercase tracking-wider text-xs rounded transition-colors">Back To The Calendar</Link>
      </div>
      <SiteFooter />
    </div>
  );
}
